import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"checkmark-2-small"} maskId="square-filled-radius-0-stroke-1-IconCheckmark2Small"><path fillRule="evenodd" clipRule="evenodd" d="M18.205 7.44502L9.82464 17.2403L5.79297 13.117L6.50798 12.4178L9.77542 15.7595L17.4452 6.79492L18.205 7.44502Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCheckmark2Small;
